import { Loadable } from '../Loadable';
export const AsyncNotFound = Loadable(() => import('./NotFound'));
